import React, {type PropsWithChildren} from 'react';
import {CdpScript} from '@/_application/modules/tracking/components/cdp.script';
import {Fragment} from '@kidslabs/mario-nextjs-react-ui-core';
import type {LayoutPlatformProps} from './layout-platform.types';
import dynamic from 'next/dynamic';

const MobileLayout = dynamic(() => import('../../collections/mobile.layout'), {ssr: true});
const DesktopLayout = dynamic(() => import('../../collections/desktop.layout'), {ssr: true});

export const LayoutPlatform = ({children, isMobile, variables}: PropsWithChildren<LayoutPlatformProps>) => {
    const Layout = isMobile ? MobileLayout : DesktopLayout;

    return (
        <Fragment>
            <CdpScript />
            <Layout variables={variables}>{children}</Layout>
        </Fragment>
    );
};
